import * as Yup from 'yup';

export const CompatibleSectionTemplatesSchema = Yup.object().shape({
  sectionTemplateIdsToInsert: Yup.array().min(
    1,
    'Veuillez choisir au moins un modèle de section.',
  ),
});
